import { useEffect, useState } from "react";
import { AccountLayout } from "../AccountLayout";
import { NSSpace, NSSpaceSizeType, NSSection, NSCopyBox, NSTitle, NSRow, NSLoading } from 'namirasoft-site-react';
import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { useParams } from "react-router-dom";
import { NamirasoftAccountToken } from "namirasoft-account";

interface TokenViewPageProps extends NSARouterMakerResult, AccountRouterProps
{
	GetToken: (id: string) => Promise<NamirasoftAccountToken>
}

interface TokenViewPageState
{
	token: string | null;
}

function TokenViewPage(props: TokenViewPageProps) 
{
	const [state, setState] = useState<TokenViewPageState>({ token: null });

	let { id } = useParams();

	useEffect(() =>
	{
		if (id)
			props.GetToken(id).then(token =>
			{
				setState({ token: token.value });
			}).catch(() => { });
		// eslint-disable-next-line
	}, [id]);
	return (
		<AccountLayout {...props}
			action={{ title: '', description: "", menus: {} }}
		>
			<NSSection>
				{
					!state.token &&
					<NSLoading />
				}
				{
					state.token &&
					<>
						<NSTitle
							title="Your Token"
						/>
						<NSSpace size={NSSpaceSizeType.MINI}></NSSpace>
						<p style={{ color: "rgba(20, 27, 92, 1)" }}>
							<strong>Copy Your Token</strong><br />
						</p>
						<NSRow>
							<p style={{ color: "rgba(20, 27, 92, 1)", maxWidth: "400px" }}>
								Copy the token below for convenient access to your service session.
								You can view it again anytime from the session list or the session view page.
							</p>
						</NSRow>
						<NSCopyBox
							title={state.token}
							value={state.token}
							classList={["justify-content-center"]}
						/>
						<NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
					</>
				}
			</NSSection>
		</AccountLayout>
	);

}
export default TokenViewPage;